import { yupResolver } from '@hookform/resolvers/yup';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import * as yup from 'yup';

import { timeZoneCityToCountry } from 'app/helpers/timeZoneCityToCountry';
import REQUEST from 'app/helpers/http.service';
import { ALL_SUBMIT_FORM } from 'app/helpers/apiEndpoint';
import { getTrackingData } from 'app/webtrack/tracking';
import { getUserLocationData, getLocaleIP } from 'app/scripts/utils';

export default function SubscribeNewsletter({ title, isNewsMargin }) {
  const { asPath } = useRouter();
  const router = useRouter();
  const [active, setActive] = useState(false);
  const [isDefaultChecked, setIsDefaultChecked] = useState(true);
  const [locationip, setLocationIP] = useState(false);

  const locationData = getUserLocationData(timeZoneCityToCountry);

  const handleCheckboxChange = e => {
    setIsDefaultChecked(e.target.checked);
  };

  const fetchIP = async () => {
    const { ip } = await getLocaleIP();
    setLocationIP(ip);
  };

  fetchIP();

  // .matches(
  //   /^(?!.*@(?:gmail|outlook|yahoo|protonmail|zoho|aol)\.\w{2,}$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  //   'Work email addresses are allowed'
  // ),
  const Schema = yup.object().shape({
    countryName: yup.string().required(),
    subscribeCheckbox: yup
      .boolean()
      .oneOf([true], 'Please accept the Privacy Policy'),
    email: yup
      .string()
      .email('Invalid email format')
      .required('Email is required'),
  });
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(Schema),
    defaultValues: {
      email: '',
      countryName: locationData.userCountry,
      purpose: 'SUBSCRIBE',
      ctaText: 'SUBSCRIBE',
      pageUrl: asPath,
      leadSource: 'Subscribe to Newsletter',
      subscribeCheckbox: isDefaultChecked,
    },
  });
  // SUBSCRIBE
  const toast = useSelector(state => state?.toast);
  const SubmitHandler = async data => {
    if (data.subscribeCheckbox) {
      try {
        const trackingData = getTrackingData();

        // Ensure WebPagesVisited is a proper string
        const cleanedTrackingData = {
          ...trackingData,
          WebPagesVisited: Array.isArray(trackingData?.WebPagesVisited)
            ? trackingData.WebPagesVisited.join(', ') // Convert array to comma-separated string
            : trackingData?.WebPagesVisited || '', // Ensure it's a string
        };
        const formData = {
          ...data,
          ipAddress: locationip,
          trackingData: cleanedTrackingData, // Use cleaned tracking data
        };
        setActive(!active);
        const res = await REQUEST({
          method: 'POST',
          url: ALL_SUBMIT_FORM,
          data: { data: formData },
        });
        if (res?.status === 200) {
          reset();
          setActive(active);
          router.push('/thankyou');
        } else toast.error(res?.data?.error?.message);
      } catch (err) {
        toast.error('failed');
      }
    }
  };

  return (
    <div
      className={`${isNewsMargin ? 'mt-0' : 'mt-10'} Subscribeff px-[18px] pb-7 pt-4 mt-10 bg-[#0050D5] drop-shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.25)] rounded-[8px]`}
    >
      <h4 className="font-[600] mb-4 leading-[27px] text-[#fff] text-[18px]">
        {title > 0 ? title : 'Subscribe to Newsletter'}
      </h4>
      <form className="space-y-3" onSubmit={handleSubmit(SubmitHandler)}>
        <div className="mb-4 grid grid-cols-12 lg:gap-x-4">
          <label
            htmlFor="email"
            className="text-[16px] font-[400] text-[#FFFFFF] col-span-12 mb-2"
          >
            Email Id
          </label>
          <input
            type="text"
            placeholder="Email"
            {...register('email')}
            name="email"
            className="col-span-8 bg-transparent text-[18px] placeholder:text-[#fff] font-[400] lg:rounded-[2px] rounded-[2px_0px_0px_2px_!important] px-[12px] py-[4px] h-[48px] w-full outline-0 text-[#fff] border border-[#FFFFFF80] focus:ring-0 focus:border-[#FFFFFF80]"
          />
          <button
            id="Subscribe"
            type="submit"
            disabled={active}
            className="pt-[0.5rem] col-span-4 font-[600] lg:text-[18px] text-[14px] text-[#0050D5] bg-[#FFF] rounded-[0px_!important] h-[48px] text-center w-full"
          >
            SUBSCRIBE
          </button>
          {errors.email && (
            <div className="mt-2 col-span-12 text-sm text-[#ffabab] font-semibold">
              {errors?.email?.message}
            </div>
          )}
        </div>

        {/* <div className="mb-3">
          <label htmlFor="countryName" hidden>
            Country
          </label>
          <select
            className="bg-white bg-[center_right_12px] bg-no-repeat appearance-none text-[14px]  placeholder:text-[#777]  tracking-[-0.4px] rounded-[2px] px-[12px] py-[4px] h-[42px]   w-full outline-0 text-[#777]  bg-[#F2F2F2]"
            // name="country"
            {...register('countryName')}
          >
            <option hidden value="">
              Select Country
            </option>
            {countries.map((countryName, key) => (
              <option value={countryName.value} key={key}>
                {countryName.name}
              </option>
            ))}
          </select>
          {errors.countryName && (
            <span className="mt-2 font-semibold text-sm  text-[#ffabab]">
              This field is required
            </span>
          )}
        </div> */}
        <input
          type="text"
          placeholder="pageUrl"
          {...register('pageUrl')}
          name="pageUrl"
          className="hidden"
        />
        <div className="mb-5">
          <label className="flex items-center space-x-1">
            <Controller
              name="subscribeCheckbox"
              control={control}
              render={({ field }) => (
                <input
                  type="checkbox"
                  className="form-checkbox rounded-full text-[#fff] bg-[#fff] border-[#fff]"
                  {...field}
                  onChange={e => {
                    field.onChange(e);
                    handleCheckboxChange(e);
                  }}
                  defaultChecked={isDefaultChecked}
                />
              )}
            />

            <span className="text-[#fff] text-[14px] font-[400]">
              By subscribing I accept the
              <Link href="/privacy-policy" className="underline ml-1">
                Privacy Policy
              </Link>
            </span>
          </label>
          {errors.subscribeCheckbox && (
            <span className="mt-2 font-semibold text-sm  text-[#ffabab]">
              {errors?.subscribeCheckbox?.message}
            </span>
          )}
        </div>
      </form>
    </div>
  );
}
